import { MessageCategories } from "../types/admin-enums";
import { IMessageReq, ITariff } from "../types/requests-interfaces";

const apiUrl = process.env.REACT_APP_API_URL;

export type TariffKind = "subscription" | "study";

export const addTariffReq = async (newMessage: any) => {
  try {
    const res = await fetch(`${apiUrl}/buttons/tariff`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newMessage),
    });

    const messageRes: IMessageReq = await res.json();
    return messageRes;
  } catch {
    return {};
  }
};

export const updateTariffReq = async (newMessage: any, tariffId: number) => {
  try {
    const res = await fetch(`${apiUrl}/buttons/tariff/${tariffId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newMessage),
    });

    const messageRes: IMessageReq = await res.json();
    return messageRes;
  } catch {
    return {};
  }
};

export const getTariffsReq = async (kind: TariffKind = "subscription") => {
  try {
    const res = await fetch(`${apiUrl}/buttons/tariffs?kind=${kind}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const messageRes: ITariff[] = await res.json();
    return messageRes;
  } catch {
    return [];
  }
};

export const getStudyTariffsReq = async () => getTariffsReq("study");

export type MiniAppDiscounts = {
  duration: Record<string, number>;
  volume: Record<string, number>;
  extra_per_subscription: number;
};

export const getMiniAppDiscountsReq = async (): Promise<MiniAppDiscounts | null> => {
  try {
    const res = await fetch(`${apiUrl}/buttons/mini-app-discounts`);
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
};

export const getTariffReq = async (id: number): Promise<ITariff | null> => {
  try {
    const res = await fetch(`${apiUrl}/buttons/tariffs/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const messageRes: ITariff = await res.json();
    return messageRes;
  } catch {
    return null;
  }
};

export const deleteTariffReq = async (id: number) => {
  try {
    const res = await fetch(`${apiUrl}/user/tariffs/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const messageRes = await res.json();
    return messageRes;
  } catch {
    return null;
  }
};
